module.exports = __webpack_public_path__ + "static/Orleans-Interior-Design-Painting-1-of-1-2ed-1024x684-cac33417d3020a314c68e2650096d892.jpg";